module.exports = __webpack_public_path__ + "static/media/icon-delete.cc0fafa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/header/images/icon-delete.svg
// module id = 963
// module chunks = 57